import { Signal, Service } from '@angular/core';
import { Observable } from 'rxjs';

import { Tenant } from '../models/classes/Tenant';

@Service({ autoProvided: false })
export abstract class ITenantService {
  /** Signal-first tenant state for modern consumers. */
  abstract readonly tenantSignal: Signal<Tenant | null>;

  /** Resolve the tenant once and publish it through tenantSignal. */
  abstract loadTenant(): Promise<Tenant>;

  abstract getTenant(): Tenant | null;

  abstract getTenantName(): string;

  abstract resetTenant(): void;

  abstract setLogo(logo: string): void;

  abstract uploadTenantLogo(file: File): Observable<string>;
}
